'use client'
import { Flex, GridItem, Heading, Text } from '@chakra-ui/react'
import { CustomGrid } from '@/components/layout/grid/CustomGrid'
import { Button } from '@/components/atoms/button'
import { useEffect } from 'react'

export default function NotFound() {
  useEffect(() => {
    document.title = 'Pagina niet gevonden'
  }, [])
  return (
    <CustomGrid height='100vh' alignItems='center'>
      <GridItem
        colStart={{ base: 1, md: 4 }}
        colSpan={{ base: 12, md: 7 }}
        mb={16}
      >
        <Flex
          justifyContent='center'
          flexDir='column'
          alignItems='center'
          gap={6}
          color='brand.tertiary'
        >
          <Text
            role='subTitle'
            fontSize='2xl'
            fontWeight={600}
            lineHeight='150%'
            color='#514B98'
          >
            404
          </Text>
          <Heading
            as='h1'
            textAlign={'center'}
            fontSize='5xl'
            lineHeight='120%'
            fontWeight={700}
            letterSpacing='-0.06rem'
          >
            Pagina niet gevonden
          </Heading>
          <Text textAlign='center' fontSize='18px' lineHeight='150%'>
            Er is een storing ontstaan. Excuus voor het ongemak!
          </Text>
          <Button text='Terug naar home' url='/' />
        </Flex>
      </GridItem>
    </CustomGrid>
  )
}
